import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletTransactions } from 'services/TransactionService'
import { GetWalletTransactionsReq } from 'types/transaction/GetTransactionsReq'

export const useTransactionsQuery = (req: GetWalletTransactionsReq) => {
  const { isEnabled = true, ...queryReq } = req
  return useQuery({
    queryKey: reactQueryKeys.walletTransactions(queryReq),
    queryFn: () => getWalletTransactions(queryReq),
    placeholderData: keepPreviousData,
    enabled: isEnabled && !!queryReq?.walletId,
  })
}
